<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
<div style="page-break-inside: avoid">
            <h5>{{ title}}</h5>
    <table class="optionalComponentSectionTable">
        <tr style="font-weight: bold;">
            <td style="text-align:left;padding-right:5px;">Type</td>
            <td style="text-align:right;padding-right:5px;">Vessel</td>
            <td style="text-align:right;padding-right:5px;">Vessel Status</td>
            <td style="text-align:right;padding-right:5px;">Lease Start</td>
            <td style="text-align:right;padding-right:5px;">Lease Duration (years)</td>
            <td style="text-align:right;padding-right:5px;">Optional Additional Years</td>
            <td style="text-align:right;padding-right:5px;">Materials</td>
        </tr>

        <tr *ngFor="let floatingUnit of floatingUnits">
            <td>{{ floatingUnit.floatingUnitType }}</td>
            <td style="text-align:right;padding-right:5px;" [innerHTML]="floatingUnit.vessel | highlight: searchTerm">
            </td>
            <td style="text-align:right;padding-right:5px;"
                [innerHTML]="floatingUnit.vesselStatus | highlight: searchTerm"></td>
            <td style="text-align:right;padding-right:5px;">{{ floatingUnit.leaseStart | date:'MMM yyyy' }}</td>
            <td style="text-align:right;padding-right:5px;">{{ floatingUnit.leaseYears }}</td>
            <td style="text-align:right;padding-right:5px;">{{ floatingUnit.leaseOptionalYears }}</td>
            <td style="text-align:right;padding-right:5px;">
                <table class="noTableBorder">
                    <tr>
                        <td style="text-align:left;padding-right:5px;"><i>Fluid</i></td>
                        <td><i>Max. Daily Capacity</i></td>
                        <td><i>Total Storage</i></td>
                    </tr>
                    <tr *ngFor="let fluid of floatingUnit.fluids">
                        <td style="text-align:left;padding-right:5px;"
                            [innerHTML]="fluid.material | highlight: searchTerm"></td>
                        <td><span *ngIf="fluid.maxDailyCapacity">{{ fluid.maxDailyCapacity | number }} {{
                                fluid.dailyRateUnit }}</span></td>
                        <td><span *ngIf="fluid.storageTotal">{{ fluid.storageTotal | number }} {{ fluid.storageUnit
                                }}</span></td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</div>
</ng-template>

<ng-template #template_mobile let-title="title">
<div style="page-break-inside: avoid">
    <h5>{{ title }}</h5>
    <div class="optionalComponentSectionTable" *ngFor="let floatingUnit of floatingUnits">
        <div>
            <span style="font-weight:bold">Type: </span>
            <span>{{ floatingUnit.floatingUnitType }}</span>
        </div>
        <div>
            <span style="font-weight:bold">Vessel: </span>
            <span [innerHTML]="floatingUnit.vessel | highlight:searchTerm"></span>
        </div>
        <div>
            <span style="font-weight:bold">Vessel Status: </span>
            <span [innerHTML]="floatingUnit.vesselStatus | highlight:searchTerm"></span>
        </div>
        <div *ngIf="floatingUnit.leaseStart">
            <span style="font-weight:bold">Lease Start: </span>
            <span>{{ floatingUnit.leaseStart | date:'MMM yyyy' }}</span>
        </div>
        <div *ngIf="floatingUnit.leaseYears">
            <span style="font-weight:bold">Lease Duration (years): </span>
            <span>{{ floatingUnit.leaseYears }}</span>
        </div>
        <div *ngIf="floatingUnit.leaseOptionalYears">
            <span style="font-weight:bold">Optional Additional Years: </span>
            <span>{{ floatingUnit.leaseOptionalYears }}</span>
        </div>
        <div>
            <span style="font-weight:bold">Materials</span>
            <table class="noTableBorder">
                <tr>
                    <td style="text-align:left;padding-right:5px;"><i>Fluid</i></td>
                    <td><i>Max. Daily Capacity</i></td>
                    <td><i>Total Storage</i></td>
                </tr>
                <tr *ngFor="let fluid of floatingUnit.fluids">
                    <td style="text-align:left;padding-right:5px;" [innerHTML]="fluid.material | highlight:searchTerm">
                    </td>
                    <td><span *ngIf="fluid.maxDailyCapacity">{{ fluid.maxDailyCapacity | number }} {{
                            fluid.dailyRateUnit }}</span></td>
                    <td><span *ngIf="fluid.storageTotal">{{ fluid.storageTotal | number }} {{ fluid.storageUnit
                            }}</span></td>
                </tr>
            </table>
        </div>
    </div>

    <!-- <table class="optionalComponentSectionTable">
    <tr style="font-weight: bold;">
      <td style="text-align:left;padding-right:5px;">Type</td>
      <td style="text-align:right;padding-right:5px;">Vessel</td>
      <td style="text-align:right;padding-right:5px;">Vessel Status</td>
      <td style="text-align:right;padding-right:5px;">Lease Start</td>
      <td style="text-align:right;padding-right:5px;">Lease Duration (years)</td>
      <td style="text-align:right;padding-right:5px;">Optional Additional Years</td>
      <td style="text-align:right;padding-right:5px;">Materials</td>
    </tr>

    <tr *ngFor="let floatingUnit of floatingUnits">
      <td>{{ floatingUnit.floatingUnitType }}</td>
      <td style="text-align:right;padding-right:5px;" [innerHTML]="floatingUnit.vessel | highlight:searchTerm"></td>
      <td style="text-align:right;padding-right:5px;" [innerHTML]="floatingUnit.vesselStatus | highlight:searchTerm"></td>
      <td style="text-align:right;padding-right:5px;">{{ floatingUnit.leaseStart | date:'MMM yyyy' }}</td>
      <td style="text-align:right;padding-right:5px;">{{ floatingUnit.leaseYears }}</td>
      <td style="text-align:right;padding-right:5px;">{{ floatingUnit.leaseOptionalYears }}</td>
      <td style="text-align:right;padding-right:5px;">
        <table class="noTableBorder">
          <tr>
            <td style="text-align:left;padding-right:5px;"><i>Fluid</i></td>
            <td><i>Max. Daily Capacity</i></td>
            <td><i>Total Storage</i></td>
          </tr>
          <tr *ngFor="let fluid of floatingUnit.fluids">
            <td style="text-align:left;padding-right:5px;" [innerHTML]="fluid.material | highlight:searchTerm"></td>
            <td><span *ngIf="fluid.maxDailyCapacity">{{ fluid.maxDailyCapacity | number }} {{ fluid.dailyRateUnit }}</span></td>
            <td><span *ngIf="fluid.storageTotal">{{ fluid.storageTotal | number }} {{ fluid.storageUnit }}</span></td>
          </tr>
        </table>
      </td>
    </tr>
  </table> -->

</div>

</ng-template>